import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Placename } from '@models';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class PlacenameService {
  private http = inject(HttpClient);

  create(c: Placename) {
    return this.http.post<Placename>(`${environment.kinkoHost}/placename/`, c, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  get(id: string) {
    return this.http.get<Placename>(`${environment.kinkoHost}/placename/${id}`);
  }

  update(p: Placename) {
    return this.http.put<Placename>(`${environment.kinkoHost}/placename/${p.id}`, p, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  delete(id: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/placename/${id}`);
  }

  addCase(id: string, caseId: string) {
    return this.http.post<void>(`${environment.kinkoHost}/placename/${id}/case/${caseId}`, null);
  }

  removeCase(id: string, caseId: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/placename/${id}/case/${caseId}`);
  }

  addReplacement(id: string, placenameId: string) {
    return this.http.post<void>(`${environment.kinkoHost}/placename/${id}/replacement/${placenameId}`, null);
  }

  removeReplacement(id: string, placenameId: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/placename/${id}/replacement/${placenameId}`);
  }

  addSameAs(id: string, placenameId: string) {
    return this.http.post<void>(`${environment.kinkoHost}/placename/${id}/alternative/${placenameId}`, null);
  }

  removeSameAs(id: string, placenameId: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/placename/${id}/alternative/${placenameId}`);
  }
}
